<div
    class="vertical-center height-100 width-100 template-radius"
    [ngStyle]="{
        'background-color': config?.backgroundColor && config.backgroundColor !== 'null' ? config.backgroundColor : 'transparent'
    }"
>
    <div class="image height-100 width-100">
        @if (config?.url) {
            <img
                class="height-100 width-100"
                [src]="config?.url"
                [ngStyle]="{
                    'object-fit': config?.displayType || 'none'
                }"
            />
        }
    </div>
</div>
